import { store } from 'react-notifications-component';

const CustomAlerts = ({ message , title, type, duration, container }) => {

    const renderMsg = () => {
        if (message && typeof(message) == 'string') {
            return message
        }
        return 'Something went wrong!'
    }

    store.addNotification({
        title: title || '',
        message: renderMsg(),
        type: type || 'warning',
        container: container || "top-right",
        dismiss: {
            duration: duration || 10000,
            onScreen: true
        }
    });
}
export default CustomAlerts